'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ga_IE = require('../vc-pagination/locale/ga_IE');

var _ga_IE2 = _interopRequireDefault(_ga_IE);

var _ga_IE3 = require('../date-picker/locale/ga_IE');

var _ga_IE4 = _interopRequireDefault(_ga_IE3);

var _ga_IE5 = require('../time-picker/locale/ga_IE');

var _ga_IE6 = _interopRequireDefault(_ga_IE5);

var _ga_IE7 = require('../calendar/locale/ga_IE');

var _ga_IE8 = _interopRequireDefault(_ga_IE7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  locale: 'ga_IE',
  Pagination: _ga_IE2['default'],
  DatePicker: _ga_IE4['default'],
  TimePicker: _ga_IE6['default'],
  Calendar: _ga_IE8['default'],
  Table: {
    filterTitle: 'Scagaire roghchlár',
    filterConfirm: 'Ceart go leor',
    filterReset: 'Athshocraigh',
    selectAll: 'Roghnaigh an leathanach reatha',
    selectInvert: 'Inbhéartaigh an leathanach reatha'
  },
  Modal: {
    okText: 'Ceart go leor',
    cancelText: 'Cealaigh',
    justOkText: 'Ceart go leor'
  },
  Popconfirm: {
    okText: 'Ceart go leor',
    cancelText: 'Cealaigh'
  },
  Transfer: {
    searchPlaceholder: 'Cuardaigh anseo',
    itemUnit: 'mír',
    itemsUnit: 'míreanna'
  },
  Upload: {
    uploading: 'Uaslódáil ...',
    removeFile: 'Bain comhad',
    uploadError: 'Earráid uaslódáil',
    previewFile: 'Comhad réamhamhairc',
    downloadFile: 'Íoslódáil an comhad'
  },
  Empty: {
    description: 'Gan aon sonraí'
  }
};